import { TYPE_DATE_COMPARISON } from './input-types';

export const id = 'shipDate';
export const apiKey = 'ShipDateTime';
export const type = TYPE_DATE_COMPARISON;

export const shipDate = {
  id,
  apiKey,
  type,
};
